import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    carousel: searchParams.get('carousel') || '1',
    user: searchParams.get('user') || '',
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 500,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 500,
    speedFast: searchParams.get('speedFast')
      ? parseInt(searchParams.get('speedFast') || '')
      : 50,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 50000,
    startFrom: parseInt(searchParams.get('startFrom') || '') || 4,
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,

    title: getDefaultValue(
      searchParams.get('title'),
      'Присылайте номер игрока'
    ),
    socials: searchParams.get('socials'),
    phoneNumber,
    // scaling
    phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || 20,
    authorFontSize: searchParams.get('authorFontSize') || 20,
    msgFontSize: searchParams.get('msgFontSize') || 30,
    opacityBg: searchParams.get('opacityBg') || 0.7,

    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    qrTitle1: searchParams.get('qrTitle1'),
    qrTitle2: searchParams.get('qrTitle2'),
    sizeQR: searchParams.get('sizeQR') || '38',

    paddingQR: searchParams.get('paddingQR') || '1.4',

    amount: searchParams.get('amount') || null,
    randomOrder: searchParams.get('randomOrder') || '0',
    fButton: searchParams.get('fButton') || 'F2',

    titleFontSize: searchParams.get('titleFontSize') || '7',
    answerFontSize: searchParams.get('answerFontSize') || '8',
    descriptionFontSize: searchParams.get('descriptionFontSize') || '5',
    questionFontSize: searchParams.get('questionFontSize') || '13',
    winnerFontSize: searchParams.get('winnerFontSize') || '5',
    winnerTitleFontSize: searchParams.get('winnerTitleFontSize') || '8',
    winnerSize: searchParams.get('winnerSize') || '35',
    titreHeight: `${searchParams.get('titreHeight') || '640'}`,
  };
};
